import { render, staticRenderFns } from "./NoticiasIndex.vue?vue&type=template&id=8f8278b2&"
import script from "./NoticiasIndex.vue?vue&type=script&lang=js&"
export * from "./NoticiasIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports